module.exports = __webpack_public_path__ + "static/media/download_center.e61c49e0.svg";